module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "이름"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addStudent($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.grade),
      expression: "grade",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "성적"
    },
    domProps: {
      "value": (_vm.grade)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addStudent($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grade = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.addStudent
    }
  }, [_vm._v("추가")])]), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.importFile
    }
  }, [_vm._v("CSV")])])]), _c('hr'), _c('transition-group', {
    staticClass: "block",
    attrs: {
      "name": "button",
      "tag": "div"
    }
  }, _vm._l((_vm.students), function(s, index) {
    return _c('student', {
      key: s.name,
      attrs: {
        "student": s,
        "show": _vm.show
      },
      on: {
        "remove": function($event) {
          _vm.removeStudent(index)
        }
      }
    })
  })), _c('hr'), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.size),
      expression: "size",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "한 조에 몇 명?"
    },
    domProps: {
      "value": (_vm.size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.size = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.makeGroup
    }
  }, [_vm._v("총 " + _vm._s(_vm.students.length) + "명 그룹 나누기")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-38007ff1"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./app/layouts/Dashboard.vue
// module id = 329
// module chunks = 0